import { create } from 'zustand';
import {
  modalsInitialState,
  createModalsSlice,
  filtersInitialState,
  createFiltersSlice,
  requestInitialState,
  createRequestSlice,
  dataInitialState,
  createDataSlice,
} from '.';
import type { ModalsState } from './modalsSlice';
import type { FiltersState, FiltersActions } from './filtersSlice';
import type { RequestState, RequestActions } from './requestSlice';
import type { DataState } from './dataSlice';

export type State = ModalsState & FiltersState & RequestState & DataState;

type Actions = {
  setOmnichannelState: (name: string, data: any) => void;
  reset: () => void;
};

export const omnichannelInitialState: State = {
  ...modalsInitialState,
  ...filtersInitialState,
  ...requestInitialState,
  ...dataInitialState,
};

export const useOmnichannelStore = create<State & Actions & FiltersActions & RequestActions>((set, get, api) => ({
  ...createModalsSlice(set, get, api),
  ...createFiltersSlice(set, get, api),
  ...createRequestSlice(set, get, api),
  ...createDataSlice(set, get, api),
  setOmnichannelState: (name, data) => {
    set(() => ({
      [name]: data,
    }));
  },
  reset: () => {
    set(omnichannelInitialState);
  },
}));
